import React, { useEffect, useLayoutEffect, useState } from "react";
import { Row, Col, message } from "antd";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ForgotPasswordForm from "../../../forms/ForgotPasswordForm";
import schema from "../../../schemas/forgotPasswordSchema";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { forgotPasswordSaga } from "./saga";
import * as selectors from "./selectors";
import "./style.css";

/* const styles = {
  loginPage: {
    height: "100%",
  },

  bgLogin: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "60%",
  },
}; */
const ForgotPasswordPage = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: forgotPasswordSaga });
  const dispatch = useDispatch();

  const loading = useSelector(selectors.selectLoading);
  const error = useSelector(selectors.selectError);
  const successMessage = useSelector(selectors.selectMessage);

  const [col, setCol] = useState(12);

  useLayoutEffect(() => {
    function updateCol() {
      if (window.innerWidth < 660) setCol(24);
      else setCol(12);
    }
    window.addEventListener("resize", updateCol);
    updateCol();
    return () => window.removeEventListener("resize", updateCol);
  }, []);

  const submitForm = (payload) => {
    dispatch(
      actions.forgotPassword({
        payloadData: { email: payload.email },
      })
    );
  };

  useEffect(() => {
    if (error && error !== "") {
      message.error(error);
      setTimeout(() => {
        dispatch(actions.initializeError());
      }, 1000);
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (successMessage && successMessage !== "") {
      message.success(successMessage);
      setTimeout(() => {
        dispatch(actions.initializeMessage());
      }, 1000);
    }
  }, [successMessage, dispatch]);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
    },
    resolver: yupResolver(schema),
  });

  return (
    <Row gutter={32} style={{ height: "100%" }}>
      <Col span={col} className="bgImage">
        <div
          /*style={{
            ...styles.bgLogin,
            backgroundImage: `url(${loginBg})`,
            height: "100%",
          }}*/
          className="bgForgotPassword"
        />
      </Col>
      <Col span={col}>
        <ForgotPasswordForm
          control={control}
          errors={errors}
          onSubmit={handleSubmit(submitForm)}
          loading={loading}
        />
      </Col>
    </Row>
  );
};

export default ForgotPasswordPage;
